import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { faqAddEdit } from "../../../../services/faqService";

const validation = {
  title: { required: true, message: "Question is required" },
  description: { required: true, message: "Answer is required" },
};

const ManageFaq = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await faqAddEdit({
        ...val,
        categoryType: "faq",
        type: "general",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-4">
          <Editor
            label="FAQ Question"
            placeholder="Who is the V’Peters"
            value={values?.title}
            onChange={(val) =>
              handleChange({ target: { name: "title", value: val } })
            }
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label="FAQ Answer"
            placeholder="the V’Peters are People"
            value={values?.description}
            onChange={(val) =>
              handleChange({
                target: { name: "description", value: val },
              })
            }
            {...formValidate(errors, "description")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Active", value: 1 },
              { name: "InActive", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "status", value: val },
              });
            }}
          />
          {/* <Input
            label="Active"
            inputPlaceholder={"Enter"}
            inputName="active"
            value={values?.active}
            onChange={handleChange}
            {...formValidate(errors, "active")}
          /> */}
        </div>
        {/* <div className="flex items-start gap-4">
          <Input
            label={"InActive"}
            inputPlaceholder={"Enter"}
            inputName="inActive"
            value={values?.inActive}
            onChange={handleChange}
            {...formValidate(errors, "inActive")}
          />
          <div className="w-full"></div>
        </div> */}
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save FAQ"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageFaq;
